import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBCyhO_WAMSfwKuK9MUBBc5gc4FolQHQ90",
  authDomain: "juris-codex.firebaseapp.com",
  projectId: "juris-codex",
  storageBucket: "juris-codex.firebasestorage.app",
  messagingSenderId: "635924825942",
  appId: "1:635924825942:web:4b36b20ce6e0f7b98f78f7",
  measurementId: "G-L4262FZJNJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
